import './DemandedJobs.scss';
import Header from "../utils/Header";
import toList from "../utils/ComponentUtil";
import TalentsAPI from "../Apis/TalentsAPI";

function PopularInternships() {
    const categories = TalentsAPI.talentTypes;
    return (<div className="demanded-jobs-wrp wrapper">
        <Header title='Popular Internship Categories' subTitle=''/>
        <div className="popular-categories">
            {toList(categories, undefined, (item, i) => 
                <div className="category">
                    <img src={item?.img} alt='category'/>
                    <div className="name">{item?.name}</div>
                </div>
            )}
        </div>
    </div>);
}

export default PopularInternships;